import * as React from "react";
import cs from "classnames";
import { PropTypes } from "prop-types";

import styles from "./index.module.scss";

function ModelInfo({ modelInfo, showModelInfo }) {
  return (
    <div
      className={cs(styles.modelInfoContainer, {
        [styles.hideModelInfo]: !showModelInfo
      })}
    >
      {modelInfo && (
        <div data-testid="model-info" className={styles.modelInfo}>
          {modelInfo}
        </div>
      )}
    </div>
  );
}

ModelInfo.defaultProps = {
  modelInfo: "",
  showModelInfo: true
};

ModelInfo.propTypes = {
  modelInfo: PropTypes.string,
  showModelInfo: PropTypes.bool
};

export default ModelInfo;
